export const CreateStore = {
  CreateStore_StepLabel_StoreInfo: 'Store info',
  CreateStore_StepLabel_Aggregators: 'Aggregators',
  CreateStore_StepLabel_ContactDetails: 'Contact details',
};
